import { render } from "./DocumentListComponent.vue?vue&type=template&id=122ed28e"
import script from "./DocumentListComponent.vue?vue&type=script&lang=js"
export * from "./DocumentListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__